import { createContext, useContext, useEffect } from "react";
import { node } from "prop-types";

import useQuery from "./use-query";

const SearchContext = createContext();

function SearchProvider({ children }) {
  const query = useQuery();

  return (
    <SearchContext.Provider value={query}>{children}</SearchContext.Provider>
  );
}

SearchProvider.propTypes = {
  children: node.isRequired,
};

function SearchConsumer({ children }) {
  return <SearchContext.Consumer>{children}</SearchContext.Consumer>;
}

SearchConsumer.propTypes = {
  children: node.isRequired,
};

function useSearchContext(baseQueryString, formType) {
  const context = useContext(SearchContext);

  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }

  // All the baseQueryString and formType to be changed,
  // but only if specifically defined
  const { setBaseQueryString, setFormType } = context;

  useEffect(() => {
    if (baseQueryString !== undefined) {
      setBaseQueryString(baseQueryString);
    }

    if (formType !== undefined) {
      setFormType(formType);
    }
  }, [baseQueryString, setBaseQueryString, setFormType, formType]);

  return context;
}

export default SearchContext;
export { SearchProvider, SearchConsumer, useSearchContext };
